import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@chakra-ui/react";
import { PlanType } from "sdk/types";
import { RadioGroupInput } from "~/components";
import { useGetMembershipPaymentAction } from "../hooks";
import { BillingIntervalRadioOption } from "./BillingIntervalRadioInput";
import { CardContainer } from "./CardContainer";
import { CardTitle } from "./CardTitle";

interface Props {
  plan: PlanType;
}

export const BillingIntervalCard: FC<Props> = ({ plan }) => {
  const { t } = useTranslation();
  const action = useGetMembershipPaymentAction();
  const billingIntervalOptions = t("planPayment.billingInterval.options", {
    returnObjects: true,
  });

  const hasFreeTrial = action == "payment";

  const radioOptions = billingIntervalOptions.map((key) => {
    return {
      plan,
      value: key,
    };
  });

  return (
    <CardContainer gap={3}>
      <CardTitle>{t("planPayment.billingInterval.heading")}</CardTitle>
      {hasFreeTrial && (
        <Text color="th.gray4" variant="th-body2">
          {t("planPayment.billingInterval.subheading")}
        </Text>
      )}
      <RadioGroupInput
        Component={BillingIntervalRadioOption}
        gap={2}
        name="billingInterval"
        options={radioOptions}
        w="full"
      />
    </CardContainer>
  );
};
